// Module
var code = "<vdc-templates></vdc-templates>\n";
// Exports
module.exports = code;